import React from "react";

export const degrowth = {
  title: "The Degrowth Toolbox for Artistic Practices",
  date: "2021 – ongoing",
  button: { url: "https://degrowthtoolbox.net/", copy: "Project website" },
  about: (
    <>
      <p>
        The toolbox is an artistic research project and open-source digital
        publication.
      </p>
      <p>
        The purpose of this artistic research is to formulate a conceptual
        framework for creative and exhibitionary practices centred on degrowth,
        while simultaneously composing a toolbox for artists, curators, as well
        as institutions, aimed towards designing ethical and sustainable
        creative practices during the pandemic and beyond.
      </p>
      <p>
        The toolbox is comprised of two main parts: first, putting forth a set
        of considerations outlining the thinking behind a degrowth approach to
        the arts, and second, proposing a set of guiding questions whose purpose
        is to direct the design of artistic projects.
      </p>
      <p>
        Degrowth is, in short, the idea that we need to construct our societies
        around the values of well-being, conviviality, autonomy, sustainability,
        inclusion, and care. These values come hand-in-hand with the rejection
        of the capitalist, authoritarian, patriarchal and colonial paradigms.
      </p>
      <p>
        The intention with this beta is to start a conversation rather than to
        present a comprehensive “guide” – such a thing would be both impossible
        and against the spirit of the toolbox itself.
      </p>
    </>
  ),
};
